/**
 * A curated list of IANA time-zone ids offered in the Preferences dialog. The
 * server accepts any IANA or Windows id (`TimeZoneInfo.FindSystemTimeZoneById`),
 * so this is a convenience shortlist covering the three MVP locales' regions
 * (US / Canada / Mexico) plus a few common international zones. The user's
 * current zone is merged in at render time if it isn't already listed, so a
 * value set out-of-band (HR feed, admin) stays selectable.
 */
export const COMMON_TIME_ZONES: readonly string[] = [
  'America/New_York',
  'America/Detroit',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Toronto',
  'America/Winnipeg',
  'America/Edmonton',
  'America/Vancouver',
  'America/Halifax',
  'America/St_Johns',
  'America/Mexico_City',
  'America/Tijuana',
  'America/Monterrey',
  'UTC',
  'Europe/London',
  'Europe/Paris',
];

/**
 * Builds the ordered option value list for the time-zone select: the browser
 * default sentinel (`''`) first, then the shortlist, with the user's current
 * zone merged in if it isn't already present.
 */
export function timeZoneOptionValues(currentZone: string | null): string[] {
  const values = [...COMMON_TIME_ZONES];
  if (currentZone && !values.includes(currentZone)) {
    values.unshift(currentZone);
  }
  return values;
}
